import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "table-component" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "row table-component-td-json" }
const _hoisted_5 = { class: "col-9 ellipsis" }
const _hoisted_6 = { class: "col-3 text-right" }
const _hoisted_7 = {
  key: 0,
  class: "text-left"
}
const _hoisted_8 = { class: "table-component-language-json" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "table-component-key-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_table, {
      ref: "tableRef",
      rows: _ctx.rows ?? _ctx.dataTable.rows,
      columns: _ctx.columnsTable,
      "no-data-label": _ctx.messageNotData,
      pagination: _ctx.dataTable.pagination,
      "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataTable.pagination) = $event)),
      "rows-per-page-label": _ctx.messageRowsPerPage,
      onRequest: _ctx.emitOnRequest,
      loading: _ctx.loading,
      "rows-per-page-options": _ctx.optionsPagination,
      "visible-columns": _ctx.visibles,
      class: _normalizeClass(_ctx.getTableStyle()),
      selection: _ctx.selection,
      selected: _ctx.items,
      "onUpdate:selected": [
        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.items) = $event)),
        _ctx.emitSelectedItems
      ],
      selectedModifiers: { sync: true },
      "row-key": _ctx.multipleSelectionKey,
      "virtual-scroll": _ctx.enableVirtualScroll,
      title: _ctx.titleTable,
      dense: "",
      onRowClick: _cache[4] || (_cache[4] = ($event, row) => _ctx.onClickCell(row, $event.target))
    }, _createSlots({
      "body-cell-actions": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_ctx.isEditEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    class: "table-component-edit-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "edit",
                    onClick: ($event: any) => (_ctx.emitEditBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Editar registro")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isConfigEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    class: "table-component-config-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "settings",
                    onClick: ($event: any) => (_ctx.isConfigBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.configTooltip), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isDetailEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 2,
                    class: "table-component-config-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "info",
                    onClick: ($event: any) => (_ctx.emitDetailBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver Detalles")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isBallotEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 3,
                    class: "table-component-ballot-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "ballot",
                    onClick: ($event: any) => (_ctx.emitBallotBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver Papeleta")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isRouteEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 4,
                    class: "table-component-route-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "route",
                    onClick: ($event: any) => (_ctx.emitRouteBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver Ruta")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isMapEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 5,
                    dense: "",
                    round: "",
                    flat: "",
                    color: "primary",
                    icon: "map",
                    onClick: ($event: any) => (_ctx.emitMapBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver Mapa")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isCompanyEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 6,
                    class: "table-component-company-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "apartment",
                    onClick: ($event: any) => (_ctx.emitCompanyBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Asignar empresas")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isQuotaEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 7,
                    class: "table-component-quota-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "paid",
                    onClick: ($event: any) => (_ctx.emitQuotaBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Gestionar cupos")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isPlanEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 8,
                    class: "table-component-plan-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "payments",
                    onClick: ($event: any) => (_ctx.emitPlanBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Gestionar planes")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isTrackingEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 9,
                    class: "table-component-tracking-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "my_location",
                    onClick: ($event: any) => (_ctx.emitTrackingBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver Rastreo")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isCheckpointEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 10,
                    class: "table-component-checkpoint",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "location_on",
                    onClick: ($event: any) => (_ctx.emitCheckpointBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver Puntos de Control")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isSectorEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 11,
                    class: "table-component-sector",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "drag_indicator",
                    onClick: ($event: any) => (_ctx.emitSectorBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver Sectores")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isStopEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 12,
                    class: "table-component-stop",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "share_location",
                    onClick: ($event: any) => (_ctx.emitStopBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver Paradas")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isStatusEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 13,
                    class: "table-component-status",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "fact_check",
                    onClick: ($event: any) => (_ctx.emitStatusBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Gestionar estados de proyecto")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isIdentifierEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 14,
                    class: "table-component-stop",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "sell",
                    onClick: ($event: any) => (_ctx.emitIdentifierBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Gestionar etiquetas de proyecto")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isIncidenceTimeEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 15,
                    class: "table-component-incidence-time",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "timer",
                    onClick: ($event: any) => (_ctx.emitIncidenceTimeBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Gestionar tiempos de incidencia")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isSendEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 16,
                    class: "table-component-send",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "send",
                    onClick: ($event: any) => (_ctx.emitSend(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Enviar datos")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isPassengerPaymentMethodEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 17,
                    class: "table-component-passenger-payment-method",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "add_card",
                    onClick: ($event: any) => (_ctx.emitPassengerPaymentMethod(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Asignar Medio de Pago a Pasajero")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isLabelPassengerEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 18,
                    dense: "",
                    round: "",
                    flat: "",
                    color: "primary",
                    icon: "group_add",
                    onClick: ($event: any) => (_ctx.emitLabelPassenger(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Asignar Clientes")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isDepositEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 19,
                    class: "table-component-deposit-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "note_add",
                    onClick: ($event: any) => (_ctx.emitDepositBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Agregar Comprobante")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isUrlEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 20,
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "link",
                    onClick: ($event: any) => (_ctx.emitUrlBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Visitar enlace externo")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isDepositImageEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 21,
                    class: "table-component-deposit-image-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "image",
                    onClick: ($event: any) => (_ctx.emitDepositImageBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver Comprobante")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isDepositReverseEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 22,
                    class: "table-component-deposit-reverse-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "assignment_return",
                    onClick: ($event: any) => (_ctx.emitDepositReverseBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Realizar Reverso del Comprobante")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              ((_ctx.isDeleteEnable && props.row.is_active) || (_ctx.isRestoreEnable && !props.row.is_active))
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 23,
                    class: _normalizeClass(props.row.is_active ? 'table-component-erase-btn' : 'table-component-restore'),
                    dense: "",
                    round: "",
                    flat: "",
                    icon: props.row.is_active ? 'do_not_disturb_on' : 'check_circle',
                    onClick: ($event: any) => (_ctx.emitIsActive(props.row))
                  }, {
                    default: _withCtx(() => [
                      (props.row.is_active == 1)
                        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Desactivar registro ")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_q_tooltip, { key: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Activar registro ")
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 2
                  }, 1032, ["class", "icon", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isEraseEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 24,
                    class: "table-component-delete-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "delete_forever",
                    onClick: ($event: any) => (_ctx.emitEraseBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Borrar registro")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isSendEmailEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 25,
                    class: "table-component-password-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "password",
                    onClick: ($event: any) => (_ctx.emitSendEmail(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Enviar contraseña temporal a correo electrónico")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isRemoveRouteEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 26,
                    class: "table-component-remove-route-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "remove_road",
                    onClick: ($event: any) => (_ctx.emitRemoveRoute(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Limpiar trazado de la ruta")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isHistoricEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 27,
                    class: "table-component-historic-btn",
                    dense: "",
                    round: "",
                    flat: "",
                    icon: "manage_history",
                    onClick: ($event: any) => (_ctx.emitHistoricBtn(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.historicTooltip), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isReloadEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 28,
                    dense: "",
                    round: "",
                    flat: "",
                    color: "primary",
                    icon: "refresh",
                    onClick: ($event: any) => (_ctx.emitReload(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Recargar la página")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isCloseSessionEnable)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 29,
                    dense: "",
                    round: "",
                    flat: "",
                    color: "negative",
                    icon: "person_remove",
                    onClick: ($event: any) => (_ctx.emitCloseSession(props.row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Cerrar sesión")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-long-name": _withCtx((props) => [
        _createVNode(_component_q_td, {
          props: props,
          class: "table-component-description"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.row.name), 1)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-incidence_label": _withCtx((props) => [
        _createVNode(_component_q_td, {
          props: props,
          class: "table-component-incidence"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.row.incidence_label), 1)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-color": _withCtx((props) => [
        _createVNode(_component_q_td, {
          props: props,
          onClick: ($event: any) => (_ctx.emitColorBtn(props.row))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: "material-symbols-outlined",
              style: _normalizeStyle(`color: ${props.row.color}; font-size: 1.4rem`)
            }, " radio_button_checked ", 4),
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode("Cambiar color de admistrador")
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["props", "onClick"])
      ]),
      "body-cell-cost_center_label": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            (props.row.incidence.incidence_identifiers.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.incidence.incidence_identifiers, (row, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(row.identifier ? row.identifier.name : ''), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (props.row.incidence.incidence_identifiers.length == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.row.cost_center_label), 1))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-description": _withCtx((props) => [
        _createVNode(_component_q_td, {
          props: props,
          class: "table-component-description"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.row.description), 1)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-description_show": _withCtx((props) => [
        _createVNode(_component_q_td, {
          props: props,
          class: "table-component-description"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.row.description), 1)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-reason": _withCtx((props) => [
        _createVNode(_component_q_td, {
          props: props,
          class: "table-component-description"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.row.reason), 1)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-active": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(props.row.is_active ? 'table-component-active' : 'table-component-inactive')
            }, _toDisplayString(props.row.active), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-status": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(props.row.is_status ? 'table-component-active' : 'table-component-inactive')
            }, _toDisplayString(props.row.status), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-status-recharger": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(props.row.status == _ctx.RechargerTransactionStatus.READY ? 'table-component-true-state' : 'table-component-false-state')
            }, _toDisplayString(props.row.status_label), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-status-monitoring": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: "material-symbols-outlined",
              style: _normalizeStyle(_ctx.getMonitoringStatusStyle(props.row)?.style)
            }, " radio_button_checked ", 4),
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getMonitoringStatusStyle(props.row)?.tooltip), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-has-connection-medium": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(props.row.has_connection_medium == 'Si' ? 'table-component-true-state' : 'table-component-false-state')
            }, _toDisplayString(props.row.has_connection_medium), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-has_payment_methods": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(props.row.has_payment_methods == 'Si' ? 'table-component-true-state' : 'table-component-false-state')
            }, _toDisplayString(props.row.has_payment_methods), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-amount_payment_methods": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(props.row.amount_payment_methods > 0 ? 'table-component-true-state' : 'table-component-false-state')
            }, _toDisplayString(props.row.amount_payment_methods), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-balance_returned": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(props.row.balance_returned == 'Si' ? 'table-component-true-state' : 'table-component-false-state')
            }, _toDisplayString(props.row.balance_returned), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-is-reverse": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(props.row.is_reverse_label == 'Si' ? 'table-component-true-state' : 'table-component-false-state')
            }, _toDisplayString(props.row.is_reverse_label), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-is-config-valid": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(props.row.is_config_label == 'Completa' ? 'table-component-true-state' : 'table-component-false-state')
            }, _toDisplayString(props.row.is_config_label), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-list-checkboxs": _withCtx((props) => [
        _createVNode(_component_q_td, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, {
              dense: "",
              padding: "",
              class: "rounded-borders"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.items, (item, index) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    padding: "",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_checkbox, {
                        modelValue: item.is_active,
                        "onUpdate:modelValue": [($event: any) => ((item.is_active) = $event), (value) => _ctx.emitItemCheckbox(value, props.row, item)],
                        "checked-icon": "task_alt",
                        "unchecked-icon": "highlight_off",
                        color: "positive",
                        label: item.name,
                        dense: _ctx.denseCheckboxs,
                        disable: item.is_disable
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "dense", "disable"])
                    ]),
                    _: 2
                  }, 1024)), [
                    [_directive_ripple]
                  ])
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      "body-cell-list-hierarchies": _withCtx((props) => [
        _createVNode(_component_q_td, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, {
              dense: "",
              padding: "",
              class: "rounded-borders"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.items, (item, index) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    padding: "",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_select, {
                        filled: "",
                        modelValue: item.hierarchy,
                        "onUpdate:modelValue": [($event: any) => ((item.hierarchy) = $event), (value) => _ctx.emitHierarchy(value, props.row)],
                        options: _ctx.getOptionsHierarchy(item.rank_hierarchy.min, item.rank_hierarchy.max),
                        dense: true,
                        disable: !item.is_active
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disable"])
                    ]),
                    _: 2
                  }, 1024)), [
                    [_directive_ripple]
                  ])
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      "body-cell-hierarchies": _withCtx((props) => [
        _createVNode(_component_q_td, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, {
              dense: true,
              padding: "",
              class: "rounded-borders"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.items, (item, index) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    padding: "",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_input, {
                        filled: "",
                        modelValue: item.hierarchy,
                        "onUpdate:modelValue": ($event: any) => ((item.hierarchy) = $event),
                        dense: true,
                        disable: true,
                        style: {"max-width":"55px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024)), [
                    [_directive_ripple]
                  ])
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      "body-cell-hierarchies-form": _withCtx((props) => [
        _createElementVNode("td", null, [
          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
            tag: "label",
            class: "table-body__col-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_select, {
                    filled: "",
                    modelValue: props.row.hierarchy,
                    "onUpdate:modelValue": [($event: any) => ((props.row.hierarchy) = $event), (value) => _ctx.emitHierarchy(value, props.row)],
                    options: _ctx.getOptionsHierarchy(props.row.rank_hierarchy.min, props.row.rank_hierarchy.max),
                    dense: true
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)), [
            [_directive_ripple]
          ])
        ])
      ]),
      "body-cell-json": _withCtx((props) => [
        _createVNode(_component_q_td, {
          style: {"padding":"0"},
          colspan: "100%"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.truncateJson(props.row?.details)), 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  icon: _ctx.iconExpanded,
                  onClick: ($event: any) => (_ctx.toggleJsonExpansion(props.row))
                }, null, 8, ["icon", "onClick"])
              ])
            ]),
            (_ctx.expandedRow == props.row)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("pre", _hoisted_8, [
                    _createTextVNode("                            "),
                    _createElementVNode("code", null, "\n                                " + _toDisplayString(props.row.details) + "\n                            ", 1),
                    _createTextVNode("\n                        ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]),
      "body-cell-status-incidence": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: _normalizeStyle(_ctx.getStatusIncidenceStyle(props.row.current_status))
            }, _toDisplayString(props.row.status_label), 5)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-priority-incidence": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.getPriorityIncidenceStyle(props.row.priority))
            }, _toDisplayString(props.row.priority_label), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      "body-cell-origin-incidence": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.getOriginIncidenceStyle(props.row.origin))
            }, _toDisplayString(props.row.origin_label), 3)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 2
    }, [
      (_ctx.enableVisibleColumns)
        ? {
            name: "top-right",
            fn: _withCtx(() => [
              _createVNode(_component_q_select, {
                modelValue: _ctx.visibles,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibles) = $event)),
                multiple: "",
                filled: "",
                dense: "",
                "options-dense": "",
                "display-value": _ctx.$q.lang.table.columns,
                "emit-value": "",
                "map-options": "",
                options: _ctx.columnsTable,
                "option-value": "name",
                "options-cover": "",
                style: {"min-width":"150px"}
              }, null, 8, ["modelValue", "display-value", "options"])
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.enableDragAndDrop)
        ? {
            name: "body",
            fn: _withCtx((props) => [
              _createVNode(_component_q_tr, {
                draggable: "true",
                onDragstart: ($event: any) => (_ctx.dragStart($event, props.row)),
                onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                onDrop: ($event: any) => (_ctx.dragDrop($event, props.row)),
                onClick: ($event: any) => (_ctx.emitRow(props.row))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col, index) => {
                    return (_openBlock(), _createBlock(_component_q_td, {
                      key: index,
                      style: _normalizeStyle(`text-align: ${col.align}`)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(props.row[col.field]) + " ", 1),
                        (col.name == 'active')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              style: _normalizeStyle((props.row.is_active ? 'color:#21BA45' : 'color:#C10015'))
                            }, _toDisplayString(props.row.active), 5))
                          : _createCommentVNode("", true),
                        (col.name == 'actions')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              (_ctx.isEditEnable)
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 0,
                                    class: "table-component-edit-btn",
                                    dense: "",
                                    round: "",
                                    flat: "",
                                    icon: "edit",
                                    onClick: ($event: any) => (_ctx.emitEditBtn(props.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Editar registro")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              ((_ctx.isDeleteEnable && props.row.is_active) || (_ctx.isRestoreEnable && !props.row.is_active))
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    class: _normalizeClass(props.row.is_active ? 'table-component-erase-btn' : 'table-component-restore'),
                                    dense: "",
                                    round: "",
                                    flat: "",
                                    icon: props.row.is_active ? 'do_not_disturb_on' : 'check_circle',
                                    onClick: ($event: any) => (_ctx.emitIsActive(props.row))
                                  }, {
                                    default: _withCtx(() => [
                                      (props.row.is_active == 1)
                                        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Desactivar registro ")
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_q_tooltip, { key: 1 }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Activar registro ")
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 2
                                  }, 1032, ["class", "icon", "onClick"]))
                                : _createCommentVNode("", true),
                              (_ctx.isEraseEnable)
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 2,
                                    class: "table-component-delete-btn",
                                    dense: "",
                                    round: "",
                                    flat: "",
                                    icon: "delete_forever",
                                    onClick: ($event: any) => (_ctx.emitEraseBtn(props.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Borrar registro")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_ctx.isConfigEnable)
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 3,
                                    dense: "",
                                    round: "",
                                    flat: "",
                                    color: "grey-7",
                                    icon: "settings",
                                    onClick: ($event: any) => (_ctx.isConfigBtn(props.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.configTooltip), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["style"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["onDragstart", "onDrop", "onClick"])
            ]),
            key: "1"
          }
        : undefined,
      (_ctx.isFooterEnable)
        ? {
            name: "bottom-row",
            fn: _withCtx(() => [
              _createVNode(_component_q_tr, { class: "bg-grey-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_td, {
                    colspan: _ctx.colspanFooter,
                    class: "text-left"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.keyFooter), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.valueFooter), 1)
                    ]),
                    _: 1
                  }, 8, ["colspan"])
                ]),
                _: 1
              })
            ]),
            key: "2"
          }
        : undefined
    ]), 1032, ["rows", "columns", "no-data-label", "pagination", "rows-per-page-label", "onRequest", "loading", "rows-per-page-options", "visible-columns", "class", "selection", "selected", "onUpdate:selected", "row-key", "virtual-scroll", "title"])
  ]))
}